<template>
  <div>
    <div class="pa-5 pt-0 pb-0">
      <v-row style="justify-content:between">
        <v-col cols="12" sm="12" md="6" lg="6" class="sub-title">Campaign Brief</v-col>
        <v-col class="pt-2" cols="12" sm="12" md="2" lg="2">
          <v-text-field
          class="mt-0"
          style="max-width:300px"
          v-model="selectedFilter.search"
          append-icon="search"
          label="Search"
          single-line
          hide-details>
          </v-text-field>
        </v-col>
        <v-col cols="12" sm="12" md="2" lg="2" v-if="isSuperAdmin || isAM">
          <v-autocomplete
            :items="AM"
            item-value="id"
            item-text="name"
            label="AM"
            v-model="selectedFilter.AM"
            hide-details
            outlined
            dense
            @change="searchFilter"
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" sm="12" md="2" lg="2" v-if="isSuperAdmin || isCC">
          <v-autocomplete
            :items="CC"
            item-value="id"
            item-text="name"
            label="CC"
            v-model="selectedFilter.CC"
            hide-details
            outlined
            dense
            @change="searchFilter"
          ></v-autocomplete>
        </v-col>
      </v-row>
    </div>
    <div class="pa-5 pt-2">
      <v-data-table
        class="campaign-brief-data-table elevation-1"
        :loading="loading"
        :headers="headers"
        :items="filteredItems"
        :search="selectedFilter.search"
        :items-per-page="5"
      >
        <template v-slot:[`item.timeline`]="{ item }">
          <td :class="`text-center ${item.overdue ? 'overdue-highlight' : ''}`">
            <a
              class="custom-link"
              :href="`/campaigns/timeline?campaignID=${item.campaignID}`"
              :target="'_blank'"
              v-if="isLinkAllow"
            >
              {{item.startDate || ''}} - {{item.endDate || ''}}
            </a>
            <span v-else>{{item.startDate || ''}} - {{item.endDate || ''}}</span>
          </td>
        </template>
        <template v-slot:[`item.name`]="{ item }">
          <td :class="`text-left ${item.overdue ? 'overdue-highlight' : ''}`">
            <a @click="openCampaignModal(item.campaignID)" class="custom-link">{{item.name || ''}}</a>
          </td>
        </template>
        <template v-slot:[`item.status`]="{ item }">
          <td :class="`text-center ${item.overdue ? 'overdue-highlight' : ''}`">
            <a
            class="custom-link"
            :href="'/campaigns/pending_approval?campaignID='+item.campaignID"
            target="_blank">
              {{getDashboardStatusDisplay(item.status)}}
            </a>
          </td>
        </template>
        <template v-slot:[`item.AMDeadline`]="{ item }">
          <td :class="`text-center ${item.overdue ? 'overdue-highlight' : ''}`">
            <a
              class="custom-link"
              :href="`/campaigns/timeline?campaignID=${item.campaignID}`"
              :target="'_blank'"
              v-if="isLinkAllow"
            >
              {{item.AMDeadline ? formatDate(item.AMDeadline) : ''}}
            </a>
            <span v-else>{{item.AMDeadline ? formatDate(item.AMDeadline) : ''}}</span>
          </td>
        </template>
      </v-data-table>
    </div>
  </div>
</template>
<script>
import config from '@/config';
import { mapState } from 'vuex'
import moment from 'moment';
import campaignConfig from '../Campaign/config'
export default {
  name: 'CampaignBriefDataTable',
  data() {
    return {
      headers: [
        {
          text: 'Deal Name',
          value: 'name',
          align: 'center'
        },
        {
          text: 'Timeline',
          value: 'timeline',
          align: 'center'
        },
        {
          text: 'Status',
          value: 'status',
          align: 'center'
        },
        {
          text: 'Deadline for approval',
          value: 'AMDeadline',
          align: 'center'
        }
      ],
      items: [],
      filteredItems: [],
      selectedFilter: {
        AM: '',
        CC: ''
      },
      dashboardStatusDisplay: campaignConfig.dashboardStatusDisplay,
      loading: false
    }
  },
  props: ['AM', 'CC'],
  computed: {
    ...mapState({
      dashboardCampaigns: state => state.campaign.dashboardBriefings,
      savedDashboardStatus: state => state.campaign.savedDashboardStatus
    }),
    isSuperAdmin: function() {
      return Number(this.$store.state.user.role) === config.userRoles.SUPER_ADMIN_HIGH
    },
    isAM: function() {
      return Number(this.$store.state.user.role) === config.userRoles.ACCOUNT_MANAGER
    },
    isCC: function() {
      return Number(this.$store.state.user.role) === config.userRoles.AD_STRATEGIST
    },
    isLinkAllow: function() {
      return Number(this.$store.state.user.role) === config.userRoles.SUPER_ADMIN_HIGH ||
      Number(this.$store.state.user.role) === config.userRoles.SUPER_ADMIN_LOW ||
      Number(this.$store.state.user.role) === config.userRoles.ACCOUNT_MANAGER
    },
    currentUserRole: function () {
      return Number(this.$store.state.user.role)
    },
    currentUserID: function () {
      return this.$store.state.user.id
    }
  },
  async mounted() {
    this.init()
    setTimeout(() => {
      this.setAMCC()
    }, 2000)
  },
  methods: {
    async init() {
      this.loading = true
      await this.$store.dispatch('campaign/getDashboardCampaigns', {})
      this.items = this.dashboardCampaigns.map(d => d)
      this.filteredItems = this.items.map(item => item)
      this.loading = false
    },
    changeStatus(item) {
      // change checkbox status
      this.$swal({
        title: 'Double Check!',
        text: 'Are you sure you want to confirm date?',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(async (result) => {
        if (result.value) {
          await this.$store.dispatch('campaign/saveDashboardStatus', {
            id: item.id,
            type: config.dashboardTypes.brief,
            status: 1
          })
          this.init()
        } else {
          item.checkedStatus = 0
        }
      })
    },
    formatDate(date) {
      if (!date || date.includes('/')) return '';
      return moment(date).format('DD/MM/YYYY');
    },
    getDashboardStatusDisplay(status) {
      if (!status) return ''
      return this.dashboardStatusDisplay[status]
    },
    searchFilter() {
      this.filteredItems = this.items.map(i => i)
      if (this.selectedFilter.AM) {
        this.filteredItems = this.filteredItems.filter(item => (item.users && item.users.includes(this.selectedFilter.AM)))
      }
      if (this.selectedFilter.CC) {
        this.filteredItems = this.filteredItems.filter(item => (item.users && item.users.includes(this.selectedFilter.CC)))
      }
    },
    openCampaignModal(campaignID) {
      this.$emit('viewCampaign', campaignID)
    },
    setAMCC() {
      if (this.currentUserRole === config.userRoles.ACCOUNT_MANAGER) {
        let matchAM = this.AM.find(a => a.id === this.currentUserID)
        this.selectedFilter.AM = matchAM
      }
      if (this.currentUserRole === config.userRoles.AD_STRATEGIST) {
        this.selectedFilter.CC = this.currentUserID
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// CampaignBriefDataTable.vue?7098887f